import React, { useState } from 'react';
import { Container, Row, Modal, Button } from 'react-bootstrap';
import { useParams, useLocation } from 'react-router-dom';

import Steps from '../../../../../../../components/steps/steps';
import ReportInfo from './components/report-info/report-info';
import ReportDocument from './components/report-documents/report-document';
import ReportReview from './components/report-preview/report-review';

import ReportsService from '../../../../../../../services/reports-service';

const DocumentSubmissionForm = ({ applicationData }) => {
  console.log(applicationData);

  const { applicationId, isin, interestPaymentDate } = useParams();
  const location = useLocation();

  const reportsService = new ReportsService();

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [formData, setFormData] = useState(applicationData);
  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');

  // Helper to merge updated data with previous formData
  const mergeFormData = (prev, update) => {
    const prevDocuments = prev?.documents || {
      pdf1: null,
      pdf2: null,
      otherDocuments: [],
    };

    const newDocuments = update?.documents || {
      pdf1: null,
      pdf2: null,
      otherDocuments: [],
    };

    return {
      ...prev,
      ...update,
      documents: {
        pdf1: newDocuments.pdf1 ?? prevDocuments.pdf1,
        pdf2: newDocuments.pdf2 ?? prevDocuments.pdf2,
        otherDocuments: Array.isArray(newDocuments.otherDocuments)
          ? newDocuments.otherDocuments
          : prevDocuments.otherDocuments,
      },
    };
  };

  const saveData = (data) => {
    setFormData((prev) => mergeFormData(prev, data));
  };

  const nextStep = async (back = false, data) => {
    let updatedFormData = formData;

    if (data) {
      updatedFormData = mergeFormData(formData, data);
      setFormData(updatedFormData);
    }

    if (isin) {
      try {
        const confirmed = false;

        await reportsService.patchTaxExemptApplication(
          applicationId,
          isin,
          interestPaymentDate,
          updatedFormData,
          confirmed
        );
      } catch (error) {
        console.error('Patch error:', error);

        const errorMessage =
          error.response?.data?.error ||
          'Failed to update data due to an unknown error.';

        setWarningMessage(errorMessage);
        setShowWarning(true);

        return;
      }
    }

    if (back && activeTabIndex > 0) {
      setActiveTabIndex((prev) => prev - 1);
    } else if (!back && activeTabIndex < 2) {
      setActiveTabIndex((prev) => prev + 1);
    }
  };

  const keys = [
    {
      id: 'form1',
      name: 'Enter Security Details',
      component: (
        <ReportInfo
          formData={formData}
          saveData={saveData}
          nextStep={nextStep}
        />
      ),
    },
    {
      id: 'form2',
      name: 'Submit Documents',
      component: (
        <ReportDocument
          formData={formData}
          saveData={saveData}
          nextStep={nextStep}
        />
      ),
    },
    {
      id: 'form3',
      name: 'Review Information',
      component: (
        <ReportReview
          formData={formData}
          nextStep={nextStep}
          applicationId={applicationId}
        />
      ),
    },
  ];

  return (
    <Container>
      <Steps activeKeyIndex={activeTabIndex} keys={keys} />

      <h1>
        <strong>{isin}</strong>
      </h1>

      <Row>{keys[activeTabIndex].component}</Row>

      <Modal show={showWarning} onHide={() => setShowWarning(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>

        <Modal.Body>{warningMessage}</Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowWarning(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default DocumentSubmissionForm;